// imports section Start
import {
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";
import qr_code from "../../../assets/images/qr_code.png";
import { QRCodeCanvas } from "qrcode.react";
// imports section End

function CashReceiptFooter({
  billOptions,
  mappedOptions,
  orderPayload,
  qrcode,
}) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Handlers start
  const {
    Table1: orderDetails = [], // Rename Table1 to orderSummary
    Table2: itemCharges = [], // Rename Table2 to itemDetails
    Table3: cartItems = [], // Rename Table3 to totals
  } = orderPayload || {};
  // Handlers end

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {mappedOptions.has(18) && (
          <Box sx={{ padding: 2, textAlign: "center" }}>
            <Divider />
            {/* <Typography variant="body2">Scan for Details</Typography> */}
            {qrcode} {/* Render the QR code */}
            <Divider />
          </Box>
        )}
        {mappedOptions.has(19) &&
          orderDetails?.[0]?.FOOTER &&
          Object.keys(orderDetails[0].FOOTER).length > 0 && (
            <Typography
              variant="sub_title"
              align="center"
              mb={1}
              fontWeight={400}
            >
              {JSON.stringify(orderDetails[0].FOOTER)}{" "}
              {/* Convert to string for display */}
            </Typography>
          )}

        {mappedOptions.has(20) && (
          <Typography
            variant="sub_title"
            align="center"
            mb={1}
            fontWeight={400}
          >
            {/* This is for footrlink */}
            {/* {orderDetails?.[0]?.INVNO} */}
          </Typography>
        )}
        {/* {mappedOptions.has(21) && (
          <Typography variant="caption" align="center" fontWeight={600}>
            {orderDetails?.[0]?.REFPOLICY}
          </Typography>
        )} */}

        {mappedOptions.has(21) &&
          orderDetails?.[0]?.REFPOLICY &&
          Object.keys(orderDetails[0].REFPOLICY).length > 0 && (
            <Typography variant="caption" align="center" fontWeight={600}>
              {JSON.stringify(orderDetails[0].REFPOLICY)}{" "}
              {/* Convert to string for display */}
            </Typography>
          )}
      </Box>
      <Divider
        sx={{
          marginY: 1,
          borderBottomWidth: 2,
          borderStyle: "dotted",
        }}
      />
    </>
  );
}

export default CashReceiptFooter;
